(function() {
  'use strict';

  // Helper functions
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsAll = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function initCarousel(carouselOrSection) {
    // If it's already a carousel element, use it directly
    // Otherwise, search for carousel within the section
    let carousel;
    if (carouselOrSection.classList && carouselOrSection.classList.contains('luxury-hero--carousel')) {
      carousel = carouselOrSection;
    } else {
      carousel = qs('.luxury-hero--carousel', carouselOrSection || document);
    }

    if (!carousel) return;

    // Skip if already initialized
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const slides = qsAll('.luxury-hero__slide', carousel);
    const dots = qsAll('.luxury-hero__dot', carousel);

    // Read autoplay settings - default to true if not set
    const autoplayAttr = carousel.getAttribute('data-autoplay');
    const autoplayEnabled = autoplayAttr === null || autoplayAttr === 'true';
    const autoplayDelay = parseInt(carousel.getAttribute('data-autoplay-delay') || '5', 10) * 1000;

    // Allow page scroll when wheeling over hero (overflow:hidden blocks default scroll)
    carousel.addEventListener('wheel', (e) => {
      window.scrollBy(0, e.deltaY);
      e.preventDefault();
    }, { passive: false });

    if (slides.length <= 1) {
      // Even with one slide, ensure it's visible
      if (slides.length === 1) {
        slides[0].classList.add('luxury-hero__slide--active');
      }
      return;
    }

    let currentIndex = 0;
    let autoplayInterval = null;
    let touchStartX = 0;
    let touchEndX = 0;
    let isTransitioning = false;

    // Update slide visibility
    function updateSlides() {
      slides.forEach((slide, index) => {
        if (index === currentIndex) {
          slide.classList.add('luxury-hero__slide--active');
        } else {
          slide.classList.remove('luxury-hero__slide--active');
        }
      });

      // Update dots
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('luxury-hero__dot--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('luxury-hero__dot--active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    // Go to specific slide
    function goToSlide(index) {
      if (index < 0 || index >= slides.length || index === currentIndex) return;

      // Allow transitions even if one is in progress (for autoplay)
      isTransitioning = true;
      currentIndex = index;
      updateSlides();

      // Reset transition lock after animation
      setTimeout(() => {
        isTransitioning = false;
      }, 600); // Match CSS transition duration
    }

    // Next slide
    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      goToSlide(nextIndex);
    }

    // Previous slide
    function prevSlide() {
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      goToSlide(prevIndex);
    }

    // Start autoplay
    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= 1) {
        return;
      }
      stopAutoplay();
      autoplayInterval = setInterval(() => {
        // Always advance, even if transitioning (will queue the next change)
        nextSlide();
      }, autoplayDelay);
    }

    // Stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Handle dot clicks
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        stopAutoplay();
        goToSlide(index);
        startAutoplay();
      });
    });

    // Delegate slide click to link (link has pointer-events: none so wheel/scroll work)
    carousel.addEventListener('click', (e) => {
      if (e.target.closest('.luxury-hero__dot')) return;
      const slide = e.target.closest('.luxury-hero__slide');
      if (!slide) return;
      const link = slide.querySelector('.luxury-hero__link');
      if (link && link.href && link.href !== '#' && !link.href.endsWith('#')) {
        e.preventDefault();
        window.location.href = link.href;
      }
    });

    // Touch/swipe support
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
      startAutoplay();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          nextSlide();
        } else {
          // Swipe right - previous slide
          prevSlide();
        }
      }
    }

    // Pause autoplay on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Pause autoplay on focus (keyboard navigation)
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    // Keyboard navigation
    carousel.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        stopAutoplay();
        prevSlide();
        startAutoplay();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        stopAutoplay();
        nextSlide();
        startAutoplay();
      }
    });

    // Initialize
    updateSlides();
    startAutoplay();

    // Cleanup on section unload (for theme editor)
    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
      document.addEventListener('shopify:section:unload', (e) => {
        if (e.detail.sectionId === carousel.id.replace('luxury-hero-', '')) {
          stopAutoplay();
        }
      });
    }
  }

  // Initialize on DOM ready
  function init() {
    const carousels = qsAll('.luxury-hero--carousel');
    carousels.forEach(carousel => {
      initCarousel(carousel);
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // If already loaded, run immediately
    init();
  }

  // Also try after a short delay as fallback
  setTimeout(init, 500);

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    const sectionElement = e.detail;
    if (sectionElement && sectionElement.querySelector) {
      const carousel = sectionElement.querySelector('.luxury-hero--carousel');
      if (carousel) {
        // Small delay to ensure section is fully rendered
        setTimeout(() => {
          initCarousel(carousel);
        }, 50);
      }
    }
  });
})();
